module.exports = __webpack_public_path__ + "img/La-base-verdun-Max-Quality.8866f519.jpg";